// ── Steam player-stats card: tooltip/guide + live refresh ─────────────────
// تعامل نمودار آمار بازیکنان استیم (tooltip، نقطه، خط راهنما) و دکمه‌ی
// «به‌روزرسانی» بدون reload. (منتقل‌شده از تگ <script> داخل steam-stats.blade.php)
// listenerها روی document با delegation بسته می‌شوند و فقط یک‌بار init می‌شوند.

export function initSteamStats() {
  if (window.__steamStatsTipInit) return;
  window.__steamStatsTipInit = true;

  const faNum = function (n) {
    try { return Number(n).toLocaleString('fa-IR'); }
    catch (e) { return String(n); }
  };
  const faTime = function (ms) {
    try {
      return new Date(ms).toLocaleString('fa-IR', {
        month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
      });
    } catch (e) { return ''; }
  };

  // e.target روی لیسنرهای document می‌تواند خودِ document باشد (نه Element)
  // که closest ندارد. بدون این گارد، هر mousemove روی ناحیهٔ خالی صفحه یک
  // TypeError پرتاب می‌کرد.
  const chartFrom = function (e) {
    const target = e && e.target;
    return target && typeof target.closest === 'function'
      ? target.closest('[data-steam-chart]')
      : null;
  };

  const move = function (e) {
    const chart = chartFrom(e);
    if (!chart) return;

    let pts = chart.__pts;
    if (!pts) {
      try { pts = JSON.parse(chart.getAttribute('data-points') || '[]'); }
      catch (err) { pts = []; }
      chart.__pts = pts;
    }
    if (!pts.length) return;

    const rect = chart.getBoundingClientRect();
    const cx = (e.touches ? e.touches[0].clientX : e.clientX);
    const ratio = Math.min(1, Math.max(0, (cx - rect.left) / rect.width));
    const idx = Math.round(ratio * (pts.length - 1));
    const p = pts[idx];

    const guide = chart.querySelector('.steam-stats__guide');
    const dot = chart.querySelector('.steam-stats__dot');
    const tip = chart.querySelector('.steam-stats__tip');

    guide.style.left = p.xp + '%';
    dot.style.left = p.xp + '%';
    dot.style.top = p.yp + '%';
    // افقی کمی clamp تا tooltip از لبه بیرون نزند.
    tip.style.left = Math.min(90, Math.max(10, p.xp)) + '%';
    tip.style.top = p.yp + '%';
    // اگر نقطه بالای نمودار است، tooltip را زیرِ نقطه بگذار تا زیر هدر نرود.
    tip.classList.toggle('is-below', p.yp < 42);
    tip.querySelector('.steam-stats__tip-val').textContent = faNum(p.v);
    tip.querySelector('.steam-stats__tip-time').textContent = faTime(p.t);

    guide.hidden = dot.hidden = tip.hidden = false;
  };

  const leave = function (e) {
    const chart = chartFrom(e);
    if (!chart) return;
    chart.querySelectorAll('.steam-stats__guide, .steam-stats__dot, .steam-stats__tip')
      .forEach(function (el) { el.hidden = true; });
  };

  document.addEventListener('mousemove', move, { passive: true });
  document.addEventListener('touchmove', move, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (chartFrom(e)) leave(e);
  }, { passive: true });
  document.addEventListener('touchend', leave, { passive: true });

  // دکمه‌ی به‌روزرسانی: با کلیک کاربر، آمار تازه می‌شود.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-steam-refresh]');
    if (!btn || btn.disabled) return;

    const url = btn.getAttribute('data-steam-refresh');
    const meta = document.querySelector('meta[name="csrf-token"]');
    btn.disabled = true;
    btn.classList.add('is-loading');

    const section = btn.closest('.steam-stats');

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': meta ? meta.getAttribute('content') : '',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    }).then(function (r) {
      return r.ok ? r.json() : Promise.reject(r);
    }).then(function (data) {
      // آپدیت درجا بدون reload تا صفحه به بالا نپرد.
      const set = function (sel, val) {
        const el = section.querySelector(sel);
        if (el && val != null) el.textContent = faNum(val);
      };
      set('[data-steam-current]', data.current);
      set('[data-steam-peak24]', data.peak_24h);
      set('[data-steam-peakall]', data.peak_all_time);

      const upd = section.querySelector('[data-steam-updated]');
      if (upd && data.fetched_at) upd.textContent = 'آخرین به‌روزرسانی: ' + data.fetched_at;

      // بازرسم نمودار از داده‌ی تازه (مسیر و نقاط از سرور می‌آید).
      const chart = section.querySelector('[data-steam-chart]');
      if (chart && data.chart) {
        const line = chart.querySelector('.steam-stats__chart-line');
        const area = chart.querySelector('.steam-stats__chart-area');
        if (data.chart.has && line && area) {
          line.setAttribute('d', data.chart.path);
          area.setAttribute('d', data.chart.area);
          chart.setAttribute('data-points', JSON.stringify(data.chart.points));
          chart.__pts = data.chart.points;
        }
      }
    }).catch(function () {
    }).finally(function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
  });
}
